'use strict';

import React, { useState, useEffect, useCallback, Fragment } from 'react';
import DataTable from 'react-data-table-component';
import Notification from 'components/Notification';
import { createCustomerFcm, getFcmList } from 'utils/network/ServiceHelper';
import { Listbox, Menu, Transition } from '@headlessui/react';
import { useNavigate } from 'react-router';
import cn from 'classnames';
import {
  DEBOUNCE_TIME,
  STATUS_NULL,
  PAGINATION,
  STATUS_UNAUTHORIZED,
  STATUS_SUCCESS
} from 'utils/constants';
import { SOURCE_OPTIONS } from 'utils/constants/Segment';
import MultiSelect from 'components/MultiSelect';

const DEVICE_TYPE = [
  {
    key: 'android',
    title: 'Android',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-5 h-5 mr-3"
        x="0"
        y="0"
        fill="#3CDB85"
        enableBackground="new 0 0 553.048 553.048"
        version="1.1"
        viewBox="0 0 553.048 553.048"
        xmlSpace="preserve"
      >
        <path d="M76.774 179.141c-9.529 0-17.614 3.323-24.26 9.969-6.646 6.646-9.97 14.621-9.97 23.929v142.914c0 9.541 3.323 17.619 9.97 24.266 6.646 6.646 14.731 9.97 24.26 9.97 9.522 0 17.558-3.323 24.101-9.97 6.53-6.646 9.804-14.725 9.804-24.266V213.039c0-9.309-3.323-17.283-9.97-23.929-6.647-6.646-14.627-9.969-23.935-9.969zM351.972 50.847L375.57 7.315c1.549-2.882.998-5.092-1.658-6.646-2.883-1.34-5.098-.661-6.646 1.989l-23.928 43.88c-21.055-9.309-43.324-13.972-66.807-13.972-23.488 0-45.759 4.664-66.806 13.972l-23.929-43.88c-1.555-2.65-3.77-3.323-6.646-1.989-2.662 1.561-3.213 3.764-1.658 6.646l23.599 43.532c-23.929 12.203-42.987 29.198-57.167 51.022-14.18 21.836-21.273 45.698-21.273 71.628h307.426c0-25.924-7.094-49.787-21.273-71.628-14.181-21.824-33.129-38.819-56.832-51.022zm-136.433 63.318c-2.552 2.558-5.6 3.831-9.143 3.831-3.55 0-6.536-1.273-8.972-3.831-2.436-2.546-3.654-5.582-3.654-9.137 0-3.543 1.218-6.585 3.654-9.137 2.436-2.546 5.429-3.819 8.972-3.819s6.591 1.273 9.143 3.819c2.546 2.558 3.825 5.594 3.825 9.137-.007 3.549-1.285 6.591-3.825 9.137zm140.086 0c-2.441 2.558-5.434 3.831-8.971 3.831-3.551 0-6.598-1.273-9.145-3.831-2.551-2.546-3.824-5.582-3.824-9.137 0-3.543 1.273-6.585 3.824-9.137 2.547-2.546 5.594-3.819 9.145-3.819 3.543 0 6.529 1.273 8.971 3.819 2.438 2.558 3.654 5.594 3.654 9.137 0 3.549-1.217 6.591-3.654 9.137zM123.971 406.804c0 10.202 3.543 18.838 10.63 25.925 7.093 7.087 15.729 10.63 25.924 10.63h24.596l.337 75.454c0 9.528 3.323 17.619 9.969 24.266s14.627 9.97 23.929 9.97c9.523 0 17.613-3.323 24.26-9.97s9.97-14.737 9.97-24.266v-75.447h45.864v75.447c0 9.528 3.322 17.619 9.969 24.266s14.73 9.97 24.26 9.97c9.523 0 17.613-3.323 24.26-9.97s9.969-14.737 9.969-24.266v-75.447h24.928c9.969 0 18.494-3.544 25.594-10.631 7.086-7.087 10.631-15.723 10.631-25.924V185.45h-305.09v221.354zM476.275 179.141c-9.309 0-17.283 3.274-23.93 9.804-6.646 6.542-9.969 14.578-9.969 24.094v142.914c0 9.541 3.322 17.619 9.969 24.266s14.627 9.97 23.93 9.97c9.523 0 17.613-3.323 24.26-9.97s9.969-14.725 9.969-24.266V213.039c0-9.517-3.322-17.552-9.969-24.094-6.647-6.53-14.737-9.804-24.26-9.804z"></path>
      </svg>
    )
  },
  {
    key: 'ios',
    title: 'iOS',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="w-5 h-5 mr-3"
        x="0"
        y="0"
        enableBackground="new 0 0 512 512"
        version="1.1"
        viewBox="0 0 512 512"
        xmlSpace="preserve"
      >
        <path d="M185.255 512c-76.201-.439-139.233-155.991-139.233-235.21 0-129.404 97.075-157.734 134.487-157.734 16.86 0 34.863 6.621 50.742 12.48 11.104 4.087 22.588 8.306 28.975 8.306 3.823 0 12.832-3.589 20.786-6.738 16.963-6.753 38.071-15.146 62.651-15.146h.146c18.354 0 74.004 4.028 107.461 54.272l7.837 11.777-11.279 8.511c-16.113 12.158-45.513 34.336-45.513 78.267 0 52.031 33.296 72.041 49.292 81.665 7.061 4.248 14.37 8.628 14.37 18.208 0 6.255-49.922 140.566-122.417 140.566-17.739 0-30.278-5.332-41.338-10.034-11.191-4.761-20.845-8.862-36.797-8.862-8.086 0-18.311 3.823-29.136 7.881C221.496 505.73 204.752 512 185.753 512h-.498zM351.343 0c1.888 68.076-46.797 115.304-95.425 112.342C247.905 58.015 304.54 0 351.343 0z"></path>
      </svg>
    )
  },
  {
    key: 'website',
    title: 'Website',
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        className="w-6 h-6"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
        />
      </svg>
    )
  }
];

function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

export default function Fcms() {
  const navigate = useNavigate();
  const columns = [
    {
      name: 'Customer ID',
      sortable: true,
      selector: 'customer_id',
      cell: function render(row) {
        return <>{row.customer_id}</>;
      }
    },
    {
      name: 'Name',
      sortable: true,
      selector: 'name',
      cell: function render(row) {
        return <>{row.name}</>;
      }
    },
    {
      name: 'Email',
      sortable: true,
      selector: 'email',
      cell: function render(row) {
        return <>{row.email}</>;
      }
    },
    {
      name: 'Source',
      sortable: true,
      selector: 'source',
      cell: function render(row) {
        return <>{row.source}</>;
      }
    },
    {
      name: 'Device Type',
      sortable: true,
      selector: 'email',
      cell: function render(row, index) {
        switch (row.device_type) {
          case 'android':
            return (
              <svg
                key={index}
                xmlns="http://www.w3.org/2000/svg"
                className="w-5 h-5 mr-3"
                x="0"
                y="0"
                fill="#3CDB85"
                enableBackground="new 0 0 553.048 553.048"
                version="1.1"
                viewBox="0 0 553.048 553.048"
                xmlSpace="preserve"
              >
                <path d="M76.774 179.141c-9.529 0-17.614 3.323-24.26 9.969-6.646 6.646-9.97 14.621-9.97 23.929v142.914c0 9.541 3.323 17.619 9.97 24.266 6.646 6.646 14.731 9.97 24.26 9.97 9.522 0 17.558-3.323 24.101-9.97 6.53-6.646 9.804-14.725 9.804-24.266V213.039c0-9.309-3.323-17.283-9.97-23.929-6.647-6.646-14.627-9.969-23.935-9.969zM351.972 50.847L375.57 7.315c1.549-2.882.998-5.092-1.658-6.646-2.883-1.34-5.098-.661-6.646 1.989l-23.928 43.88c-21.055-9.309-43.324-13.972-66.807-13.972-23.488 0-45.759 4.664-66.806 13.972l-23.929-43.88c-1.555-2.65-3.77-3.323-6.646-1.989-2.662 1.561-3.213 3.764-1.658 6.646l23.599 43.532c-23.929 12.203-42.987 29.198-57.167 51.022-14.18 21.836-21.273 45.698-21.273 71.628h307.426c0-25.924-7.094-49.787-21.273-71.628-14.181-21.824-33.129-38.819-56.832-51.022zm-136.433 63.318c-2.552 2.558-5.6 3.831-9.143 3.831-3.55 0-6.536-1.273-8.972-3.831-2.436-2.546-3.654-5.582-3.654-9.137 0-3.543 1.218-6.585 3.654-9.137 2.436-2.546 5.429-3.819 8.972-3.819s6.591 1.273 9.143 3.819c2.546 2.558 3.825 5.594 3.825 9.137-.007 3.549-1.285 6.591-3.825 9.137zm140.086 0c-2.441 2.558-5.434 3.831-8.971 3.831-3.551 0-6.598-1.273-9.145-3.831-2.551-2.546-3.824-5.582-3.824-9.137 0-3.543 1.273-6.585 3.824-9.137 2.547-2.546 5.594-3.819 9.145-3.819 3.543 0 6.529 1.273 8.971 3.819 2.438 2.558 3.654 5.594 3.654 9.137 0 3.549-1.217 6.591-3.654 9.137zM123.971 406.804c0 10.202 3.543 18.838 10.63 25.925 7.093 7.087 15.729 10.63 25.924 10.63h24.596l.337 75.454c0 9.528 3.323 17.619 9.969 24.266s14.627 9.97 23.929 9.97c9.523 0 17.613-3.323 24.26-9.97s9.97-14.737 9.97-24.266v-75.447h45.864v75.447c0 9.528 3.322 17.619 9.969 24.266s14.73 9.97 24.26 9.97c9.523 0 17.613-3.323 24.26-9.97s9.969-14.737 9.969-24.266v-75.447h24.928c9.969 0 18.494-3.544 25.594-10.631 7.086-7.087 10.631-15.723 10.631-25.924V185.45h-305.09v221.354zM476.275 179.141c-9.309 0-17.283 3.274-23.93 9.804-6.646 6.542-9.969 14.578-9.969 24.094v142.914c0 9.541 3.322 17.619 9.969 24.266s14.627 9.97 23.93 9.97c9.523 0 17.613-3.323 24.26-9.97s9.969-14.725 9.969-24.266V213.039c0-9.517-3.322-17.552-9.969-24.094-6.647-6.53-14.737-9.804-24.26-9.804z"></path>
              </svg>
            );
          case 'ios':
            return (
              <svg
                key={index}
                xmlns="http://www.w3.org/2000/svg"
                className="w-5 h-5 mr-3"
                x="0"
                y="0"
                enableBackground="new 0 0 512 512"
                version="1.1"
                viewBox="0 0 512 512"
                xmlSpace="preserve"
              >
                <path d="M185.255 512c-76.201-.439-139.233-155.991-139.233-235.21 0-129.404 97.075-157.734 134.487-157.734 16.86 0 34.863 6.621 50.742 12.48 11.104 4.087 22.588 8.306 28.975 8.306 3.823 0 12.832-3.589 20.786-6.738 16.963-6.753 38.071-15.146 62.651-15.146h.146c18.354 0 74.004 4.028 107.461 54.272l7.837 11.777-11.279 8.511c-16.113 12.158-45.513 34.336-45.513 78.267 0 52.031 33.296 72.041 49.292 81.665 7.061 4.248 14.37 8.628 14.37 18.208 0 6.255-49.922 140.566-122.417 140.566-17.739 0-30.278-5.332-41.338-10.034-11.191-4.761-20.845-8.862-36.797-8.862-8.086 0-18.311 3.823-29.136 7.881C221.496 505.73 204.752 512 185.753 512h-.498zM351.343 0c1.888 68.076-46.797 115.304-95.425 112.342C247.905 58.015 304.54 0 351.343 0z"></path>
              </svg>
            );
          default:
            return (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="h-5 w-5 mr-3"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                />
              </svg>
            );
        }
      }
    },
    {
      name: 'Actions',
      cell: function render(row) {
        return (
          <div className="w-full">
            <button
              className="p-1 text-center bg-gray-100 border rounded-lg leading-5 transition-colors duration-150 active:bg-purple-600 hover:bg-gray-300 focus:outline-none focus:shadow-outline-gray"
              onClick={handleCreateEdit(row)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-5 h-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                />
              </svg>
            </button>
          </div>
        );
      }
    }
  ];

  const [fcms, setFcms] = useState([]);
  const [source, setSource] = useState('');
  const [dataFcms, setDataFcms] = useState(null);
  const [pagination, setPagination] = useState({
    page: PAGINATION.DEFAULT_PAGE,
    perPage: PAGINATION.DEFAULT_PER_PAGE,
    totalPage: PAGINATION.DEFAULT_TOTAL_PAGE,
    totalData: PAGINATION.DEFAULT_TOTAL_DATA
  });
  const [form, setForm] = useState({
    customer_id: '',
    id: null,
    name: '',
    email: '',
    device_type: DEVICE_TYPE[0],
    fcm_token: ''
  });
  const [createEdit, setCreateEdit] = useState(false);
  const [notification, setNotification] = useState({
    show: false,
    error: false,
    title: '',
    message: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [sortProp, setSortProp] = useState({
    order: 'created_at',
    sort: 'desc'
  });
  const [search, setSearch] = useState('');
  const [deviceType, setDeviceType] = useState('');

  async function fetchCustomerFcmList() {
    const body = {
      limit: pagination.perPage,
      offset: pagination.page,
      device_type: deviceType,
      keyword: search,
      order: sortProp.order,
      sort: sortProp.sort,
      source: source
    };

    const baseUrl = process.env.REACT_APP_BASE_URL;

    try {
      const res = await getFcmList(baseUrl, body);
      setIsLoading(false);

      if (res?.status === STATUS_SUCCESS) {
        setFcms(res?.data);
        setDataFcms(res);
        return;
      }

      if (res?.data === STATUS_NULL) {
        notif('Error', res?.error_message, true);
        return;
      }

      if (res?.status === STATUS_UNAUTHORIZED) {
        localStorage.clear();
        navigate('/login', { replace: true });
        return;
      }

      const err = JSON.parse(await res.text());
      if (err) {
        notif('Error', err.message, true);
        return;
      }

      notif('Error', 'Network error. Please try again later!', true);
    } catch (error) {
      notif('Error', 'Network error. Please try again later!', true);
    }
  }

  async function fetchAllCustomerFcmsAndDownloads() {
    try {
      const body = {
        limit: dataFcms.total_data,
        offset: PAGINATION.DEFAULT_PAGE,
        keyword: '',
        order: 'created_at',
        sort: 'desc'
      };

      const baseUrl = process.env.REACT_APP_BASE_URL;
      const res = await getFcmList(baseUrl, body);

      if (res?.status === STATUS_SUCCESS) {
        downloadCSV(res.data);
      }
    } catch (e) {
      return;
    }
  }

  function convertArrayOfObjectsToCSV(array) {
    let result;

    const columnDelimiter = ';';
    const lineDelimiter = '\n';
    const objKeys = array[0];

    delete objKeys.id;
    delete objKeys.created_at;
    delete objKeys.updated_at;

    const keys = Object.keys(objKeys);

    result = '';
    result += keys.join(columnDelimiter);
    result += lineDelimiter;

    array.forEach((item) => {
      let ctr = 0;
      keys.forEach((key) => {
        if (ctr > 0) result += columnDelimiter;
        result += item[key];
        ctr++;
      });

      result += lineDelimiter;
    });

    return result;
  }

  function downloadCSV(array) {
    const link = document.createElement('a');
    let csv = convertArrayOfObjectsToCSV(array);
    if (csv == STATUS_NULL) {
      notif('Error', 'Failed to generate CSV', true);
      return;
    }

    const filename = 'fcm_master.csv';
    if (!csv.match(/^data:text\/csv/i)) {
      csv = `data:text/csv:charset=utf-8,${csv}`;
    }

    link.setAttribute('href', encodeURI(csv));
    link.setAttribute('download', filename);
    link.click();
  }

  function handlePerRowsChange(newPerPage, page) {
    setPagination({
      ...pagination,
      page,
      perPage: newPerPage,
      totalPage: Math.ceil(fcms / newPerPage)
    });
  }

  function handlePageChange(page) {
    setPagination({
      ...pagination,
      page
    });
  }

  const handleCreateEdit = (row) => () => {
    if (row)
      setForm({
        ...form,
        customer_id: row.customer_id,
        name: row.name,
        email: row.email,
        device_type: DEVICE_TYPE.find((e) => e.key === row.device_type),
        fcm_token: row.fcm_token,
        id: row.id
      });
    setCreateEdit(true);
  };

  function closeCreateEdit() {
    setCreateEdit(false);
  }

  function handleChangeForm(e) {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  }

  const debouncedSearchTerm = useDebounce(search, DEBOUNCE_TIME);

  useEffect(() => {
    fetchCustomerFcmList();
  }, []);

  useEffect(() => {
    fetchCustomerFcmList();
  }, [debouncedSearchTerm]);

  useEffect(() => {
    fetchCustomerFcmList();
  }, [pagination.page, pagination.perPage, deviceType, source]);

  function handleSearchChange(e) {
    setSearch(e.target.value);
    setPagination({ ...pagination, page: 1 });
  }

  function handleDeviceTypeChange(value) {
    setForm({
      ...form,
      device_type: DEVICE_TYPE.find((e) => e.key === value)
    });
  }

  const handleSort = useCallback((column, sortDirection) => {
    setSortProp({
      order: column.selector,
      sort: sortDirection
    });
  });

  function notif(title, message, isError = false, duration = 3000) {
    setNotification({
      show: true,
      title: title,
      message: message,
      error: isError
    });

    setTimeout(() => {
      setNotification({ ...notification, show: false });
    }, duration);
  }

  function closeNotification() {
    setNotification({ ...notification, show: false });
  }

  function isValid() {
    return (
      form.name?.length > 0 &&
      form.email?.length > 0 &&
      form.fcm_token?.length > 0
    );
  }

  useEffect(() => {
    if (!createEdit)
      setForm({
        ...form,
        customer_id: '',
        name: '',
        email: '',
        device_type: DEVICE_TYPE[0],
        fcm_token: '',
        id: null
      });
  }, [createEdit]);

  async function handleCreateEditCustomerFcm() {
    if (!isValid()) {
      notif('Error', 'Please fill all required field!', true);
      return;
    }

    try {
      const baseUrl = process.env.REACT_APP_BASE_URL;
      form.device_type = form.device_type.key;

      if (form.id) {
        // edit customer fcm
        form.customer_id = parseInt(form.customer_id);
        form.level = parseInt(form.level);
        const res = await createCustomerFcm(baseUrl, form);

        if (res?.status === STATUS_SUCCESS) {
          notif('Success', 'Customer FCM successfully updated!');

          closeCreateEdit();
          setIsLoading(true);
          fetchCustomerFcmList();
          return;
        }

        if (res?.status === STATUS_UNAUTHORIZED) {
          localStorage.clear();
          navigate('/login', { replace: true });
          return;
        }

        const err = JSON.parse(await res.text());
        if (err) {
          notif('Error', err.message, true);
          return;
        }

        notif('Error', 'Network error. Please try again later!', true);
      } else {
        // create customer fcm
        form.customer_id = parseInt(form.customer_id);
        const res = await createCustomerFcm(baseUrl, form);

        if (res?.status === STATUS_SUCCESS) {
          notif('Success', 'Customer FCM successfully created!');

          closeCreateEdit();
          setIsLoading(true);
          fetchCustomerFcmList();
          return;
        }

        if (res?.status === STATUS_UNAUTHORIZED) {
          localStorage.clear();
          navigate('/login', { replace: true });
          return;
        }

        const err = JSON.parse(await res.text());
        if (err) {
          notif('Error', err.message, true);
          return;
        }

        notif('Error', 'Network error. Please try again later!', true);
      }
    } catch (error) {
      notif('Error', 'Network error. Please try again later!', true);
    }
  }

  const onClickDeviceType = (type) => {
    setDeviceType(type);
    fetchCustomerFcmList(type);
  };

  return (
    <div>
      <div className="flex flex-row items-center justify-between">
        <h2 className="my-6 text-xl font-semibold text-gray-700 dark:text-gray-200">
          Customer FCM
        </h2>
        <div>
          <button
            className="px-4 py-2 mt-3 mr-3 text-sm font-medium text-center bg-white border border-yellow-500 rounded-lg text-secondary leading-5 text-purple transition-colors duration-150 active:bg-yellow-600 hover:bg-yellow-100 focus:outline-none focus:shadow-outline-purple"
            onClick={fetchAllCustomerFcmsAndDownloads}
          >
            Export CSV
          </button>
          <button
            className="px-4 py-2 mt-3 text-sm font-medium text-center text-white border border-transparent rounded-lg leading-5 transition-colors duration-150 bg-secondary hover:bg-yellow-700 focus:outline-none focus:shadow-outline-purple"
            onClick={handleCreateEdit(null)}
          >
            Add New
          </button>
        </div>
      </div>
      <div className="flex flex-row items-center gap-3 w-full">
        <div className="relative">
          <input
            className="block w-full px-3 py-2 text-sm border appearance-none rounded-md dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
            placeholder="John Doe"
            name="search"
            value={search}
            onChange={handleSearchChange}
          />
          <div className="absolute top-0 bottom-0 flex flex-row items-center h-full right-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-5 h-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>
        </div>

        <MultiSelect
          data={SOURCE_OPTIONS}
          onChange={(value) =>
            setSource(value.map((item) => item.value).join(','))
          }
        />

        <Menu as="div" className="relative inline-block text-left">
          <div>
            <Menu.Button className="inline-flex w-full justify-center rounded-md">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 0 0-.659-1.591L3.659 7.409A2.25 2.25 0 0 1 3 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0 1 12 3Z"
                />
              </svg>
            </Menu.Button>
          </div>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute z-10 right-0 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg focus:outline-none">
              <div className="px-1 py-1 ">
                <Menu.Item>
                  {({ active }) => (
                    <button
                      className={cn(
                        'group flex w-full items-center rounded-md px-2 py-2 text-sm flex-row gap-3',
                        {
                          'bg-purple-200': active,
                          'bg-purple-700 text-white': deviceType === '',
                          'text-gray-900': deviceType !== ''
                        }
                      )}
                      onClick={() => onClickDeviceType('')}
                    >
                      <span>All Devices</span>
                    </button>
                  )}
                </Menu.Item>
                {DEVICE_TYPE.map((type) => (
                  <Menu.Item key={type.key}>
                    {({ active }) => (
                      <button
                        className={cn(
                          'group flex w-full items-center rounded-md px-2 py-2 text-sm flex-row gap-3',
                          {
                            'bg-purple-200': active,
                            'bg-purple-700 text-white': deviceType === type.key,
                            'text-gray-900': deviceType !== type.key
                          }
                        )}
                        onClick={() => onClickDeviceType(type.key)}
                      >
                        {type.icon}
                        <span>{type.title}</span>
                      </button>
                    )}
                  </Menu.Item>
                ))}
              </div>
            </Menu.Items>
          </Transition>
        </Menu>
      </div>
      <DataTable
        columns={columns}
        data={fcms}
        responsive
        sortServer
        onSort={handleSort}
        progressPending={isLoading}
        pagination
        paginationServer
        paginationTotalRows={dataFcms?.total_data}
        onChangeRowsPerPage={handlePerRowsChange}
        onChangePage={handlePageChange}
      />

      {/* Create Edit Section */}
      <Transition
        show={createEdit}
        enter="transition-all ease-in duration-100"
        enterFrom="opacity-0"
        enterTo="opacity-100"
      >
        <div className="fixed inset-0 z-20 overflow-y-auto">
          <div className="flex items-end justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            <div className="fixed inset-0">
              <div className="absolute inset-0 bg-gray-100 opacity-75"></div>
            </div>
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen"></span>
            <div
              className="inline-block px-8 pt-5 pb-8 overflow-hidden text-left align-bottom bg-white rounded-lg shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
              role="dialog"
              aria-modal="true"
              aria-labelledby="modal-headline"
            >
              {form.id ? (
                <h3 className="mb-3 font-bold">Edit Customer FCM</h3>
              ) : (
                <h3 className="mb-3 font-bold">Create Customer FCM</h3>
              )}

              <div
                className="absolute cursor-pointer top-3 right-3"
                onClick={closeCreateEdit}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-6 h-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>

              <label className="block mt-3 text-sm">
                <span className="text-gray-700 dark:text-gray-400">
                  Customer ID <span className="text-red-500">*</span>
                </span>
                <input
                  className="block w-full px-3 py-2 mt-1 text-sm border appearance-none rounded-md dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                  placeholder="Customer ID"
                  name="customer_id"
                  value={form.customer_id}
                  onChange={handleChangeForm}
                />
              </label>
              <label className="block mt-3 text-sm">
                <span className="text-gray-700 dark:text-gray-400">
                  Name <span className="text-red-500">*</span>
                </span>
                <input
                  className="block w-full px-3 py-2 mt-1 text-sm border appearance-none rounded-md dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                  placeholder="John Doe"
                  name="name"
                  value={form.name}
                  onChange={handleChangeForm}
                />
              </label>
              <label className="block mt-3 text-sm">
                <span className="text-gray-700 dark:text-gray-400">
                  Email <span className="text-red-500">*</span>
                </span>
                <input
                  className="block w-full px-3 py-2 mt-1 text-sm border appearance-none rounded-md dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                  placeholder="john@doe.com"
                  name="email"
                  value={form.email}
                  onChange={handleChangeForm}
                />
              </label>

              <label className="block mt-3 text-sm">
                <span className="text-gray-700 dark:text-gray-400">
                  Device Type <span className="text-red-500">*</span>
                </span>
                <Listbox
                  value={form.device_type}
                  onChange={handleDeviceTypeChange}
                >
                  <div className="relative mt-1">
                    <Listbox.Button className="relative w-full py-2 pl-3 pr-10 text-left bg-white border rounded-lg cursor-default focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-75 focus-visible:ring-white focus-visible:ring-offset-orange-300 focus-visible:ring-offset-2 focus-visible:border-indigo-500 sm:text-sm">
                      <span className="block truncate">
                        {form.device_type?.title}
                      </span>
                      <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="w-5 h-5"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M8 9l4-4 4 4m0 6l-4 4-4-4"
                          />
                        </svg>
                      </span>
                    </Listbox.Button>
                    <Transition
                      as={Fragment}
                      leave="transition ease-in duration-100"
                      leaveFrom="opacity-100"
                      leaveTo="opacity-0"
                    >
                      <Listbox.Options className="absolute w-full py-1 mt-1 overflow-auto text-base bg-white shadow-lg rounded-md max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                        {DEVICE_TYPE.map((device, index) => (
                          <Listbox.Option
                            key={index}
                            className={({ active }) =>
                              cn(
                                'cursor-default select-none relative py-2 pl-10 pr-4',
                                {
                                  'text-amber-900 bg-amber-100': active,
                                  'text-gray-900': !active
                                }
                              )
                            }
                            value={device.key}
                          >
                            {({ selected, active }) => (
                              <>
                                <span
                                  className={cn('block truncate', {
                                    'font-medium': selected,
                                    'font-normal': !selected
                                  })}
                                >
                                  {device.title}
                                </span>
                                {selected ? (
                                  <span
                                    className={cn(
                                      'absolute inset-y-0 left-0 flex items-center pl-3',
                                      {
                                        'text-amber-600': active
                                      }
                                    )}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      className="w-5 h-5"
                                      fill="none"
                                      viewBox="0 0 24 24"
                                      stroke="currentColor"
                                    >
                                      <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth={2}
                                        d="M5 13l4 4L19 7"
                                      />
                                    </svg>
                                  </span>
                                ) : null}
                              </>
                            )}
                          </Listbox.Option>
                        ))}
                      </Listbox.Options>
                    </Transition>
                  </div>
                </Listbox>
              </label>
              <label className="block mt-3 text-sm">
                <span className="text-gray-700 dark:text-gray-400">
                  FCM Token <span className="text-red-500">*</span>
                </span>
                <input
                  className="block w-full px-3 py-2 mt-1 text-sm border appearance-none rounded-md dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input"
                  name="fcm_token"
                  value={form.fcm_token}
                  onChange={handleChangeForm}
                />
              </label>
              <div className="flex flex-row-reverse">
                <button
                  className="px-4 py-2 mt-3 text-sm font-medium text-center text-white border border-transparent rounded-lg leading-5 transition-colors duration-150 bg-secondary hover:bg-yellow-700 focus:outline-none focus:shadow-outline-purple"
                  onClick={handleCreateEditCustomerFcm}
                >
                  {form.id ? 'Edit' : 'Create'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Transition>

      <Notification
        notification={notification}
        closeNotification={closeNotification}
      />
    </div>
  );
}
